<template>
  <div>
    <XNav :content="[{ t: 'common.faq' }]"/>
    <div class="faq">
      <p class="bold">{{ $t("pug.faq.q1") }}</p>
      <p class="text">{{ $t("pug.faq.a1") }}</p>
      <p class="bold">{{ $t("pug.faq.q2") }}</p>
      <p class="text">{{ $t("pug.faq.a2") }}</p>
      <p class="bold">{{ $t("pug.faq.q3") }}</p>
      <p class="text">{{ $t("pug.faq.a3") }}</p>
      <p class="bold">{{ $t("pug.faq.q4") }}</p>
      <p class="text">{{ $t("pug.faq.a4") }}</p>
      <p class="bold">{{ $t("pug.faq.q5") }}</p>
      <p class="text">{{ $t("pug.faq.a5") }}</p>
      <p class="text">{{ $t("pug.faq.a5a") }}</p>
      <p class="text">{{ $t("pug.faq.a5b") }}</p>
      <p class="bold">{{ $t("pug.faq.q5") }}</p>
      <p class="text">{{ $t("pug.faq.a5") }}</p>
      <p class="bold">{{ $t("pug.faq.q6") }}</p>
      <p class="text">{{ $t("pug.faq.a6") }}</p>
      <p class="bold">{{ $t("pug.faq.q7") }}</p>
      <p class="text">{{ $t("pug.faq.a7") }}</p>
      <p class="bold">{{ $t("pug.faq.q8") }}</p>
      <p class="text">{{ $t("pug.faq.a8") }}</p>
      <p class="bold">{{ $t("pug.faq.q9") }}</p>
      <p class="text">{{ $t("pug.faq.a9") }}</p>
      <p class="bold">{{ $t("pug.faq.q10") }}</p>
      <p class="text">{{ $t("pug.faq.a10") }}</p>
    </div>
  </div>  
</template>

<script>
import XNav from "@/components/XNav.vue";

export default {
  name: "PUG-FAQ",
  metaInfo() {
    return {
      title: this.$t("seo_metadata.pug_faq.title"),
      meta: [
        { vmid: "description", name: "description", content: this.$t("seo_metadata.pug_faq.description") },
        { vmid: "keywords", name: "keywords", content: this.$t("seo_metadata.keywords") },
        { vmid: "og:title", property: "og:title", content: this.$t("seo_metadata.pug_faq.title") },
        { vmid: "og:description", property: "og:description", content: this.$t("seo_metadata.pug_faq.description") },
        { vmid: "og:url", property: "og:url", content: "https://kingsleague.ca/pug/faq" },
        { vmid: "og:type", property: "og:type", content: "website" },
        { vmid: "twitter:title", name: "twitter:title", content: this.$t("seo_metadata.pug_faq.title") },
        { vmid: "twitter:description", name: "twitter:description", content: this.$t("seo_metadata.pug_faq.description") }
      ],
      link: [{ rel: "canonical", href: "https://kingsleague.ca/pug/faq" }],
      script: [{
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": this.$t("pug.faq.q1"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a1") } },
            { "@type": "Question", "name": this.$t("pug.faq.q2"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a2") } },
            { "@type": "Question", "name": this.$t("pug.faq.q3"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a3") } },
            { "@type": "Question", "name": this.$t("pug.faq.q4"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a4") } },
            { "@type": "Question", "name": this.$t("pug.faq.q5"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a5") } },
            { "@type": "Question", "name": this.$t("pug.faq.q6"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a6") } },
            { "@type": "Question", "name": this.$t("pug.faq.q7"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a7") } },
            { "@type": "Question", "name": this.$t("pug.faq.q8"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a8") } },
            { "@type": "Question", "name": this.$t("pug.faq.q9"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a9") } },
            { "@type": "Question", "name": this.$t("pug.faq.q10"), "acceptedAnswer": { "@type": "Answer", "text": this.$t("pug.faq.a10") } }
          ]
        }
      }]
    };
  },
  components: {
    XNav,
  }
};
</script>

<style lang="scss" scoped>
@import "@/theme.scss";

  .bold {
    @extend %font-bold;
    margin-top: 10px;
    font-size: 18px;
  }

  .text {
    margin-top: 5px;
    margin-left: 10px;
    font-size: 16px;
  }


  @media only screen and (max-width: 600px) {
    .faq {
      width: 70vw;
      min-width: initial;
    }

    .bold {
      font-size: 16px;
    }

    .text {
      font-size: 14px;
    }
  }
</style>